import { useWatch } from 'react-hook-form';
import { REPLIES } from '../HoldUntilReply.constants';
import { useHoldUntilReplyContext } from '../HoldUntilReplyContext';
import { useMemo } from 'react';

export const flattenLocaleButtonTitles = (localeButtons: Record<string, string[]>): string[] => {
  return [...new Set(Object.values(localeButtons).flat())];
};

export const useQuickReplies = () => {
  const { quickReplies } = useHoldUntilReplyContext();
  const replies = useWatch({ name: REPLIES });
  const flattenedQuickReplies = useMemo(
    () => flattenLocaleButtonTitles(quickReplies),
    [quickReplies],
  );

  const availableQuickReplies = useMemo(() => {
    const existingReplies = new Set(
      replies?.flatMap((reply: { variants: Array<{ variant: string }> }) =>
        reply.variants.map((variant: { variant: string }) => variant.variant),
      ) || [],
    );
    return flattenedQuickReplies.filter((reply) => !existingReplies.has(reply));
  }, [flattenedQuickReplies, replies]);

  return {
    filteredQuickReplies: availableQuickReplies,
    quickReplies: flattenLocaleButtonTitles(quickReplies),
  };
};
